import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';

export interface CanDeactivateSubmissionDetails {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root',
})
export class CanDeactivateSubmissionDetailsGuard implements CanDeactivate<CanDeactivateSubmissionDetails> {
  canDeactivate(component: CanDeactivateSubmissionDetails): boolean | Observable<boolean> {
    return component.canDeactivate ? component.canDeactivate() : true;
  }
}
